// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__xE4GX","resendInfoText":"OnGoingPaymentBox_resendInfoText__36w6L"};